import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { CircularProgress, Button } from "@material-ui/core";
export const CalculateBuyoutButton = ({ calculationIsLoading, contractIsLoading, isMileageRequired }) => {
    const { values, isSubmitting, isValid, submitForm } = useFormikContext();
    if (contractIsLoading) {
        return null;
    }
    const isMileageFilled = () => {
        const mileageValue = values.mileage;
        return mileageValue != null && mileageValue !== 0 && !isNaN(mileageValue);
    };
    const isDisabled = calculationIsLoading ||
        isSubmitting ||
        !values.registrationNumber.trim() ||
        !values.buyoutDate ||
        !isValid ||
        (isMileageRequired && !isMileageFilled());
    return (_jsx(Button, { variant: "contained", color: "primary", size: "large", fullWidth: true, onClick: submitForm, disabled: isDisabled, children: calculationIsLoading ? _jsx(CircularProgress, { size: 20 }) : "Beregn utkjøp" }));
};
//# sourceMappingURL=CalculateBuyoutButton.js.map